export {
  default as UsuarioClienteVinculoTabContainer
} from './views/usuarioClienteVinculoTabContainer';
export { default as UsuarioClienteVinculoManager } from './usuarioClienteVinculoManager';
